import { Component, OnInit, Input } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ProgramService } from "../../services/program.service";
import { Program } from "../../interfaces/program.model";
import { NavBarService } from "../../services/nav-bar.service";

@Component({
  selector: "app-program-container",
  templateUrl: "./program-container.component.html",
  styleUrls: ["./program-container.component.scss"],
  providers: [NavBarService]
})
export class ProgramContainerComponent implements OnInit {
  program: Program = {
    id: 0,
    number: 0,
    name: null,
    estimated: 0,
    realised: 0,
    forecast: 0,
    space: 0,
    imageUrl: null
  };
  loading = true;
  navbarData: any = { title: "-", color: 1 };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ProgramService,
    private NavBarService: NavBarService
  ) {}

  ngOnInit() {
    if (this.program) {
      this.NavBarService.setData({
        title: `${this.program.number}. ${this.program.name}`,
        color: this.program.number,
        crumbs: [
          {
            text: `${this.program.number}. ${this.program.name}`,
            link: `/programma/${this.program.id}`,
            active: true
          }
        ]
      });
    }
    this.NavBarService.data.subscribe(a => {
      this.navbarData = a;
    });


    this.route.params
      .switchMap((params: Params) => this.service.getProgram(+params["id"]))
      .subscribe(a => {
        this.program = <Program>{
          id: a.id,
          number: a.Weergavenummer,
          name: a.naam,
          estimated: a.begroot,
          realised: a.gerealiseerd,
          forecast: a.prognose,
          space: a.ruimte,
          imageUrl: a.ImageUrl
        };

        this.loading = false;
        this.NavBarService.setData({
          title: `${a.Weergavenummer}. ${a.naam}`,
          color: a.Weergavenummer,
          crumbs: [
            {
              text: `${a.Weergavenummer}. ${a.naam}`,
              link: `/programma/${a.id}`,
              active: true
            }
          ]
        });
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/program-container/program-container.component.ts